/*
  Naar Halı — kargo/teslim tarihi (26 Eki 2026)

  <naar-teslim data-hazirlik="0|2" data-bicim="urun|sepet"> elemanını doldurur.
  Hesap tarayıcıda yapılır: sayfa Shopify önbelleğinden gelse de tarih ve
  geri sayım güncel kalır. Saat dilimi Türkiye (UTC+3, yaz saati yok).

  KURALLAR (işletme kararı, 26 Eki 2026)
    · Hafta içi 12:00'ye kadar verilen sipariş aynı gün, sonrası ertesi iş günü kargoya verilir.
    · Patina / Overdye / Loya: önce 2 iş günü üretim, sonra kargo (data-hazirlik="2",
      hangi ürünün 2 aldığı snippets/naar-teslim-hazirlik.liquid'de).
    · Kargoda geçen süre: 1–2 iş günü (KARGO_GUN_EN_AZ / KARGO_GUN_EN_COK). Tek tarih yerine
      aralık gösterilir: yakın illere ertesi gün, uzak illere (ör. Siirt) ikinci gün ulaşıyor;
      ürün sayfasında müşterinin ilini bilmiyoruz.
    · İş günü = Pazartesi–Cuma, aşağıdaki resmî tatiller hariç.

  TATİL LİSTESİ her yıl güncellenmeli (dini bayramlar her yıl ~11 gün kayar).
*/
(function () {
  if (customElements.get('naar-teslim')) return;

  var KESIM_SAATI = 12;
  var KARGO_GUN_EN_AZ = 1;
  var KARGO_GUN_EN_COK = 2;
  var TATILLER = [
    '2026-10-29',
    '2027-01-01', '2027-03-09', '2027-03-10', '2027-03-11', '2027-04-23', '2027-05-01',
    '2027-05-16', '2027-05-17', '2027-05-18', '2027-05-19', '2027-07-15', '2027-08-30', '2027-10-29'
  ];
  var AYLAR = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];
  var GUNLER = ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'];

  /* Türkiye saatindeki "şimdi"; UTC alanları Türkiye saatini taşır */
  function simdi() { return new Date(Date.now() + 3 * 3600 * 1000); }
  function gun(d) { return new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate())); }
  function ekle(d, n) { return new Date(d.getTime() + n * 86400000); }
  function anahtar(d) { return d.toISOString().slice(0, 10); }
  function isGunu(d) {
    var g = d.getUTCDay();
    return g !== 0 && g !== 6 && TATILLER.indexOf(anahtar(d)) === -1;
  }
  function sonrakiIsGunu(d) { do { d = ekle(d, 1); } while (!isGunu(d)); return d; }
  function isGunuEkle(d, n) { while (n-- > 0) d = sonrakiIsGunu(d); return d; }
  function tarihYaz(d) { return d.getUTCDate() + ' ' + AYLAR[d.getUTCMonth()] + ' ' + GUNLER[d.getUTCDay()]; }
  /* "28 – 29 Ekim" / "30 Ekim – 2 Kasım" */
  function aralikYaz(a, b) {
    if (a.getUTCMonth() === b.getUTCMonth()) return a.getUTCDate() + ' – ' + b.getUTCDate() + ' ' + AYLAR[b.getUTCMonth()];
    return a.getUTCDate() + ' ' + AYLAR[a.getUTCMonth()] + ' – ' + b.getUTCDate() + ' ' + AYLAR[b.getUTCMonth()];
  }

  function hesapla(hazirlik) {
    var an = simdi();
    var bugun = gun(an);
    var kesimOncesi = isGunu(bugun) && an.getUTCHours() < KESIM_SAATI;
    var baslangic = kesimOncesi ? bugun : sonrakiIsGunu(bugun);
    var kargo = isGunuEkle(baslangic, hazirlik);
    var kalanDk = kesimOncesi ? (KESIM_SAATI * 60) - (an.getUTCHours() * 60 + an.getUTCMinutes()) : 0;
    return {
      bugun: bugun,
      kargo: kargo,
      teslimIlk: isGunuEkle(kargo, KARGO_GUN_EN_AZ),
      teslimSon: isGunuEkle(kargo, KARGO_GUN_EN_COK),
      kalanDk: kalanDk
    };
  }

  function kargoEtiketi(h) {
    var fark = Math.round((h.kargo - h.bugun) / 86400000);
    if (fark === 0) return 'Bugün kargoda';
    if (fark === 1) return 'Yarın kargoda';
    if (fark < 7) return GUNLER[h.kargo.getUTCDay()] + ' kargoda';
    return tarihYaz(h.kargo) + ' kargoda';
  }

  function kalanYaz(dk) {
    var sa = Math.floor(dk / 60), d = dk % 60;
    return (sa ? sa + ' sa ' : '') + (d ? d + ' dk ' : '') + 'kaldı';
  }

  class NaarTeslim extends HTMLElement {
    connectedCallback() {
      this.ciz();
      var self = this;
      this._zaman = setInterval(function () { self.ciz(); }, 60000);
    }
    disconnectedCallback() { clearInterval(this._zaman); }
    ciz() {
      var hazirlik = parseInt(this.dataset.hazirlik || '0', 10) || 0;
      var h = hesapla(hazirlik);

      if (this.dataset.bicim === 'sepet') {
        this.textContent = 'Ücretsiz kargo · Tahmini teslimat ' + aralikYaz(h.teslimIlk, h.teslimSon);
        return;
      }

      var baslik = this.querySelector('[data-teslim-baslik]');
      var aciklama = this.querySelector('[data-teslim-aciklama]');
      var tarih = this.querySelector('[data-teslim-tarih]');
      if (!baslik || !aciklama || !tarih) return;

      baslik.textContent = kargoEtiketi(h);
      if (hazirlik > 0) {
        aciklama.textContent = 'Bu model siparişinize özel ' + hazirlik + ' iş gününde üretilip kargoya verilir.';
      } else if (h.kalanDk > 0) {
        aciklama.textContent = '12:00’ye kadar verilen siparişler aynı gün kargoya verilir · ' + kalanYaz(h.kalanDk) + '.';
      } else {
        aciklama.textContent = 'Hafta içi 12:00’ye kadar verilen siparişler aynı gün kargoya verilir.';
      }
      tarih.textContent = aralikYaz(h.teslimIlk, h.teslimSon);
      this.classList.toggle('naar-teslim--bugun', hazirlik === 0 && h.kalanDk > 0);
      this.hidden = false;
    }
  }

  customElements.define('naar-teslim', NaarTeslim);
})();
